export default __webpack_public_path__ + "static/media/filterCheckedIcon.e24b754f.svg";